<template>
  <div class="listing-item__short-sale" v-if="showTeaser && teaserText"><span v-html="isSalePage ? convertSale(props.data) : teaserText "></span></div>
</template>

<script lang="ts" setup>
import { displayTextPriceCP, displayPrice,displayCustomPriceCP1 } from "~/utils/displayPrice"
import { toDate } from 'date-fns-tz';

interface ShortSale {
  text: string;
  teaser: string;
  date_from: string;
  date_end: string;
  price: number;
}
const wooStore = useWooStore();
const emit = defineEmits<{
  (e: "isTeaser"): void;
  (e: "shortTerm", price: string): void;
}>();

type Sale = {
  schedule: {
    date_from: string;
    date_end: string;
    price: string;
  };
  short: {
    date_from: string;
    date_end: string;
    price: string;
  };
  teaser?: {
    text: string;
    datetime: string;
  }
};

const getTimestampZone = (date: string) => {
  const timezone = 'Asia/Singapore';
  const dateNew = toDate(new Date(date), { timeZone: timezone });
  return Math.floor(dateNew.getTime() / 1000);
}

const getTimeNow = () => {
  const sgTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Singapore' });
  return Math.floor(new Date(sgTime).getTime() / 1000);
}

const getSalePrice = (sale: Sale) =>  {
  const now = getTimeNow();
  let shortStart = 0;
  let shortEnd = 0;

  // let scheduleStart = 0;
  // let scheduleEnd = 0;
  // let schedulePrice = 0;

  if( sale.short ) {
    shortStart = getTimestampZone(sale.short.date_from) || 0;
    shortEnd = getTimestampZone(sale.short.date_end) || 0;
  }

  // if( sale.schedule ) {
  //   scheduleStart = getTimestampZone(sale.schedule.date_from) || 0;
  //   scheduleEnd = getTimestampZone(sale.schedule.date_end) || 0;
  //   schedulePrice = parseFloat(sale.schedule.price);
  // }
console.log('---- lorem',sale,sale.short);
  let teaser: any = {};
  if( sale?.teaser ) {
    let teaserDate = getTimestampZone(sale.teaser.datetime) || 0;
    if( now >= teaserDate && shortStart > 0 && now <= shortStart ) {
      console.log('=======> TEASER');
      teaser = {
        datetime: sale.teaser.datetime,
        text: sale.teaser.text,
        price: sale.short.price
      };
      return {...sale.short, teaser};
    }
  }

  // if (shortStart > 0 && now >= shortStart && now <= shortEnd) {
  //     console.log('=========> SHORRT');
  //     return {...sale.short, teaser};
  // }

  // if( scheduleStart > 0 && scheduleEnd > 0 ) {
  //     if( now >= scheduleStart && now <= scheduleEnd ) {
  //         return { ...sale.schedule, schedule: true, teaser };
  //     }

  //     return {
  //         schedule: true,
  //         expired: true,
  //     };
  // }

  //  if( scheduleStart == 0 && scheduleEnd == 0 ) {
  //     // if( now >= scheduleStart && now <= scheduleEnd ) {
  //     //     return { ...sale.schedule, schedule: true, teaser };
  //     // }

  //     return {
  //         schedule: true,
  //         expired: true,
  //     };
  // }

  // if (
  //     (scheduleStart > now || scheduleEnd || schedulePrice > 0) ||
  //     now >= scheduleStart &&
  //     now <= scheduleEnd
  // ) {
  //     console.log('=========> SCHEDULEE');
  //     return { ...sale.schedule, schedule: true, teaser };
  // }

  return {};
}

const props = defineProps(["data","p_id","text_teaser"]);

const formatToQuestionMarks = (price: string): string => {
    // Remove commas
    const withoutCommas = price.replace(/,/g, '');

    // Extract currency prefix
    const currencyMatch = withoutCommas.match(/([A-Z]+\$|\$)/)[0];

    // Get numbers only
    const numbers = withoutCommas.replace(/[A-Z]+\$|\$/g, '');

    // Keep first digit, replace rest with ?
    const firstDigit = numbers[0];
    const questionMarks = '?'.repeat(numbers.length - 1);

    return `${currencyMatch}${firstDigit}${questionMarks}`;
}

const extractPrefix = (text: string): string => {
    return text.split('$')[0].trim();
}

const showTeaser = ref(false);
const teaserText = ref();
const convertSale = (data: ShortSale) => {
const priceMask = formatToQuestionMarks(data.price.toString());

const text = extractPrefix(data.text);
    return text+ ' ' + priceMask;
};

const formatShortTermSale = (price: string) => {
  const priceStr = price.toString();
  const firstDigit = priceStr.charAt(0);
  const numOfRemainingDigits = priceStr.length - 1;
  const questionMarks = '?'.repeat(numOfRemainingDigits);

  return `${firstDigit}${questionMarks}`;
}

const getDateFrom = (currentTime: number, sale: any) => {
  let closestDate = Infinity;

  for (const key in sale) {
    if (sale[key].date_from) {
      let dateValue = getTimestampZone(sale[key].date_from);

      if (dateValue >= currentTime && dateValue < closestDate) {
        return sale[key];
      }
    }
  }
}

//// emmmmmmmmmmmmmmmmmmmmmmmmmmmm
const isSalePage = ref(false);
const getShortSaleDisplay = () => {

  if ( Object.keys(props.data).length === 0) {
    return;
  }
  

  const sale = props.data;
  let saleTearser = '';
  let saleStart = '';
  let saleEnd = '';
  let saleText = '';
  if( typeof sale.teaser == 'undefined' || typeof sale.short == 'undefined') {
    return;
  }
  const currentTime = getTimeNow();


  if( typeof sale.teaser != 'undefined' ) {
    saleTearser = sale.teaser.datetime;
    saleText = sale.teaser.text;
  }
  if( typeof sale.short != 'undefined' ) {
  
    const getSale = sale.short;

    if( Object.keys(getSale).length > 0  ) {

      // const _dateFrom = getTimestampZone(getSale.date_from) || 0;
      // const _dateEnd = getTimestampZone(getSale.date_end) || 0;

      if ( sale.teaser && Object.keys(sale.teaser).length > 0 ) {
        showTeaser.value = true;
        let tesearTextItem = sale.teaser.text;
        if (props.text_teaser && props.text_teaser != 'undefined') {
          tesearTextItem = props.text_teaser;
        }

        teaserText.value = tesearTextItem.replace('XXX', wooStore.currency.symbol + formatShortTermSale(getSale?.price.toString()));
        emit("isTeaser");
        //console.log('aaaaaaa', showTeaser.value);
      }


    }
    return;
  }


 
};

// getShortSaleDisplay();

watch(
  () => wooStore.currency,
  (newVal, oldVal) => {
    getShortSaleDisplay();
  },
  { immediate: true, deep: true } // optional
)

watch(() => props.data, (newVal) => {
  getShortSaleDisplay();
}, { deep: true, immediate: true });
</script>

<style lang="css">
.listing-item__short-sale{
  align-items: center;
  background: linear-gradient(270.63deg, #e83c04 -.72%, #ad073d 100.06%);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin: 0 auto 20px;
  min-height: 39px;
  padding-left: 30px;
  padding-right: 30px;
  position: relative;
  transition: .6s;
  width: 100%;
}
.listing-item__short-sale span {
    color: #fff;
    font-weight: 600;
    letter-spacing: .6px;
    line-height: 24px;
}
</style>